import { Middleware } from 'one-ring';

const bannerMappings = [
    Middleware.CreateMapping('message', 'message'),
    Middleware.CreateMapping('banners', 'banners'),    
];
function ConfigureMiddleware() {
    if (!Middleware.CheckMappingExists('banner', 'GET')) {
        Middleware.RegisterMapping('banner', 'GET', bannerMappings);        
    }
}

const banner = {
    ConfigureMiddleware
};

export default banner;
